import { defineComponent as _defineComponent } from 'vue'
import { useI18n } from 'vue-i18n-composable'



export default /*#__PURE__*/_defineComponent({
  __name: 'LfRequiredFiedsLegendComponent',
  props: {
  showRequiredFieldsAdvice: {
    type: Boolean,
    default: true,
    required: false
  }
},
  setup(__props) {

const props = __props;




const { t } = useI18n()

const legend = t('components.form_generator.required_fields')

return { __sfc: true,props, t, legend }
}

})